/* aurala_product-picker.js
   One custom element. On pill change it writes the chosen variant into the hidden
   name="id" input that Dawn's buy-buttons already renders, and swaps the displayed
   price and the tile image. The image values are read off the pill, which Liquid filled
   from that variant's own featured_image, so no image is named in code. Nothing else on the page is touched: every query is rooted at the element or
   its own card, so two picker sections on one page cannot interfere.

   Why JS at all: Dawn's own PDP variant picker (<variant-selects>) is a custom element
   too, so this matches Dawn's model rather than working around it. With the script
   absent the pills simply stop switching and add-to-cart still posts the default
   variant, which is exactly the behaviour before the pills existed.

   Replaces live's approach: 298 lines including a whole-card click delegate, dot
   pagination and its own money formatter that ignored shop.money_format. */
if (!customElements.get('aurala-variant-pills')) {
  customElements.define(
    'aurala-variant-pills',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.onChange);
      }

      onChange(event) {
        const pill = event.target.closest('.aurala-picker__variant-input');
        if (!pill) return;

        const card = this.closest('.aurala-picker__card');
        if (!card) return;

        const hidden = card.querySelector('.product-variant-id');
        if (hidden) {
          hidden.value = pill.value;
          hidden.disabled = false;
        }

        const now = card.querySelector('[data-picker-now]');
        if (now) now.textContent = pill.dataset.price || now.textContent;

        const image = card.querySelector('[data-picker-image]');
        if (image && pill.dataset.imageSrc) {
          image.src = pill.dataset.imageSrc;
          image.srcset = pill.dataset.imageSrcset || '';
          if (pill.dataset.imageAlt) image.alt = pill.dataset.imageAlt;
        }

        const was = card.querySelector('[data-picker-was]');
        if (was) {
          const compare = pill.dataset.compare || '';
          was.textContent = compare;
          was.hidden = compare === '';
        }
      }
    }
  );
}
